import { useState } from "react";
import * as XLSX from "xlsx";
import styled from "styled-components";
import GreenButton from "../../../../ui/GreenButton.js";




const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 16px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: #575757;
  background-color: transparent;
  transition: transform 0.1s;
  font-size: medium;
  font-weight: bold;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div3 = styled.div`
  width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Div4 = styled.div`

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 24px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;



  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    button {
      align-self: stretch;
      margin-top: 12px;
    }
  }
`;
const H2 = styled.h2`
  font-size: 18px;
  color: #575757;
  margin: 0 0 8px 0;
`;


const ServicosLista = styled.div`
  background-color: #f5f5f5;
  margin: 0px 0 20px 0;
  padding: 15px;
  border-radius: 0px 0px 8px 8px;
`;

const ServicoItem = styled.div`
  padding: 10px;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border-bottom: none;
  }

  p {
    margin: 4px 0;
    font-size: 16px;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Container2 = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column; // <- força em coluna no mobile
  }
`;



const ServicosWrapper = styled.div`
  max-height: ${({ expandido }) => (expandido ? '500px' : '0')};
  overflow-y: scroll;
  transition: max-height 0.5s ease;
`;
const Div7 = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  p{
    color: #575757;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

  }
`;
const Div8 = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;


`;


const CustosWrapper = styled.div`
  margin-top: 8px;
  margin-left: 20px;
  padding: 10px 15px;
    background-color: #fff;
  border-left: 4px solid #E0F0FF;
  border-radius: 6px;

  ul {
    margin: 0;
    padding: 0;
    list-style: inside;
  }

  li {
    margin-bottom: 4px;
  }
`;

const ValorMonetario = styled.span`
  text-align: right;
  font-weight: 600;
  min-width: 150px;
  display: inline-block;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 2px solid #ccc;

  span {
    user-select: none;
  }
`;




const Grid = ({ listaContratoLocacao, listaParcela, listaTotalPorContrato, listaItensPorContrato }) => {




  const [osExpandida, setOsExpandida] = useState(null);
  const [parcelaExpandida, setParcelaExpandida] = useState(null);


  //===========================================================================================Ordenar a tabela
  const [sortConfig, setSortConfig] = useState({ key: 'NUMEROCONTRATO', direction: 'asc' });
  const sortedLista = [...listaContratoLocacao].sort((a, b) => {
    const { key, direction } = sortConfig;

    let aVal = a[key];
    let bVal = b[key];

    if (key === 'TOTAL_CONTRATO') {
      // ordenar como número
      aVal = Number(aVal);
      bVal = Number(bVal);
    }

    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    return 0;
  });


  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  //===========================================================================================Exportar Excel
  const exportarParaExcelContratos = () => {
    const linhas = [];

    sortedLista.forEach((contrato) => {
      const parcelasDoContrato = listaParcela.filter(
        (p) => p.NUMEROCONTRATO === contrato.NUMEROCONTRATO
      );

      const totalDoContrato = listaTotalPorContrato.find(
        (p) => p.NUMEROCONTRATO === contrato.NUMEROCONTRATO
      );

      // Cabeçalho do contrato
      linhas.push([`📄 Contrato: ${contrato.NUMEROCONTRATO} - ${contrato.DESC_CONTRATO}`]);
      linhas.push([`🏢 Fornecedor: ${contrato.COD_FORNECEDOR} - ${contrato.NOME_FORNECEDOR}`]);
      linhas.push([`📆 Data de Criação: ${contrato.DATA_FORMATADA}`]);
      linhas.push([
        `💰 Total do Contrato:`,
        Number(totalDoContrato?.TOTAL_CONTRATO || contrato.TOTAL_CONTRATO || 0),
      ]);
      linhas.push([]); // linha em branco

      parcelasDoContrato.forEach((parcela) => {
        linhas.push([
          `Parcela ${parcela.PARCELA}`,
          `Data de Lançamento: ${new Date(parcela.DATA_LANCAMENTO).toLocaleDateString("pt-BR")}`,
          `Valor da Parcela: ${Number(parcela.TOTAL_PARCELA).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })}`,
        ]);

        const objetosCusto = listaItensPorContrato.filter(
          (obj) =>
            obj.NUMEROCONTRATO === contrato.NUMEROCONTRATO &&
            obj.PARCELA === parcela.PARCELA
        );

        objetosCusto.forEach((obj) => {
          const qtde = Number(obj.QTDE) || 0;
          const vlrUnit = Number(obj.VLRUNITARIO) || 0;
          const total = Number(obj.VLRTOTAL) || 0;

          linhas.push([
            `   • ${obj.DESC_OBJETOCUSTO}`,
            `${qtde} x ${vlrUnit.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}`,
            total,
          ]);
        });

        linhas.push([]); // espaço entre parcelas
      });

      linhas.push([]); // espaço entre contratos
    });

    // Geração do arquivo Excel
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(linhas);
    XLSX.utils.book_append_sheet(wb, ws, "Relatório Contratos");
    XLSX.writeFile(wb, "central_ti_contratos.xlsx");
  };

  return (



    <Container>
      <GreenButton onClick={exportarParaExcelContratos}>
        Exportar Excel
      </GreenButton>
      <Div3>
        <HeaderRow>
          <span onClick={() => handleSort("NUMEROCONTRATO")} style={{ cursor: 'pointer', flex: 1 }}>
            📅 Contrato {sortConfig.key === 'NUMEROCONTRATO' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
          </span>

          <span onClick={() => handleSort("TOTAL_CONTRATO")} style={{ cursor: 'pointer', flex: 1, textAlign: 'right' }}>
            💰 Total {sortConfig.key === 'TOTAL_CONTRATO' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
          </span>

          <span style={{ flex: 0.5, textAlign: 'right' }}>
            🔍 Ações
          </span>
        </HeaderRow>

        {sortedLista.map((item, i) => {
          const parcelasDoContrato = listaParcela.filter(
            (p) => p.NUMEROCONTRATO === item.NUMEROCONTRATO
          );

          const totalDoContrato = listaTotalPorContrato.find(
            (p) => p.NUMEROCONTRATO === item.NUMEROCONTRATO
          );


          return (
            <div key={i}>
              <Div4>
                <Div8>
                  <H2>N° contrato: {item.NUMEROCONTRATO}</H2> <H2>Descrição:{item.DESC_CONTRATO}</H2>
                  <Div7>
                    <p><strong>Fornecedor:</strong> {item.COD_FORNECEDOR} - {item.NOME_FORNECEDOR}</p>
                    <p><strong>Data criação:</strong> {item.DATA_FORMATADA}</p>
                    <p>
                      <strong>Total:</strong>{" "}
                      {totalDoContrato
                        ? Number(item.TOTAL_CONTRATO).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                        : "Não disponível"}
                    </p>
                  </Div7>
                </Div8>

                <Button onClick={() =>
                  setOsExpandida(prev => prev === item.NUMEROCONTRATO ? null : item.NUMEROCONTRATO)
                }>
                  {osExpandida === item.NUMEROCONTRATO ? 'Ocultar...' : 'Ver dados...'}
                </Button>
              </Div4>

              <ServicosWrapper expandido={osExpandida === item.NUMEROCONTRATO}>
                <ServicosLista>
                  {parcelasDoContrato.length === 0 ? (
                    <p>Nenhuma parcela encontrada.</p>
                  ) : (

                    parcelasDoContrato.map((servico, idx) => {
                      const chaveParcela = `${item.NUMEROCONTRATO}-${servico.PARCELA}`;
                      const objetosCusto = listaItensPorContrato.filter(
                        (obj) =>
                          obj.NUMEROCONTRATO === item.NUMEROCONTRATO &&
                          obj.PARCELA === servico.PARCELA
                      );

                      return (
                        <ServicoItem key={idx}>
                          <Container2>
                            <Div8>
                              <Div7>
                                <span>Parcela {servico.PARCELA}:</span>

                                <span>
                                  Lançado:{" "}
                                  {new Date(servico.DATA_LANCAMENTO).toLocaleDateString("pt-BR")}
                                </span>

                                <ValorMonetario>
                                  {Number(servico.TOTAL_PARCELA).toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  })}
                                </ValorMonetario>

                              </Div7>

                            </Div8>
                            <Button
                              onClick={() =>
                                setParcelaExpandida((prev) =>
                                  prev === chaveParcela ? null : chaveParcela
                                )
                              }
                            >
                              {parcelaExpandida === chaveParcela ? "Ocultar gastos" : "Ver gastos"}
                            </Button>


                          </Container2>

                          {/* BLOCO DE CUSTOS FORA DO CONTAINER2 */}
                          {parcelaExpandida === chaveParcela && (
                            <CustosWrapper>
                              {objetosCusto.length === 0 ? (
                                <p>Nenhum objeto de custo.</p>
                              ) : (
                                <ul>
                                  {objetosCusto.map((obj, i) => (
                                    <li
                                      key={i}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                      }}
                                    >
                                      <span>
                                        <strong>{obj.DESC_OBJETOCUSTO}</strong>:
                                      </span>

                                      <ValorMonetario>
                                        {obj.QTDE} x{" "}
                                        {Number(obj.VLRUNITARIO).toLocaleString("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        })}{" "}
                                        ={" "}
                                        {Number(obj.VLRTOTAL).toLocaleString("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        })}
                                      </ValorMonetario>
                                    </li>


                                  ))}
                                </ul>
                              )}
                            </CustosWrapper>
                          )}
                        </ServicoItem>
                      );
                    })


                  )}
                </ServicosLista>
              </ServicosWrapper>
            </div>
          );
        })}

      </Div3>


    </Container>

  );
};


export default Grid;
